import { Navigate, useLocation } from "react-router-dom";

export default function LegacyMemberElectionsRedirect() {
  const location = useLocation();
  return <Navigate to={`/people/membership-services/member-elections${location.search}`} replace />;
}
